<div *ngIf="activeFlow$ | async as flow">
  <ng-container *ngIf="flow === 'adult' || flow === 'aya'">
    <div class="extras-step__title" i18n>Every city has multiple options. Choose your accommodation depending on your needs.</div>
    <lx-accommodations-type [accommodations]="accommodations" [optional]="accommodationOptional"></lx-accommodations-type>
  </ng-container>
  <ng-container *ngIf="flow === 'junior'">
    <lx-premium-activities [premiumActivities]="premiumActivities"></lx-premium-activities>
    <div class="extras-step__extra">
      <lx-premium-accommodation [premiumAccommodation]="premiumAccommodation" *ngIf="!!premiumAccommodation?.code"></lx-premium-accommodation>
    </div>
  </ng-container>
</div>
